import type { NDateLocale } from './enUS'
import { ca } from 'date-fns/locale'

const dateCaES: NDateLocale = {
  name: 'ca-ES',
  locale: ca
}

export default dateCaES
